import React from 'react';
import ReactDOM from 'react-dom';
import { X, UserPlus, UserCheck, Calendar, Clock, MapPin, Music2 } from 'lucide-react';
import { getEventTypeColor, getEventTypeIcon } from '../eventHelpers';
import { renderLiveIndicator, renderOverBadge } from '../eventComponents';

const DJScheduleModal = ({ 
  show, 
  onClose, 
  selectedDJ, 
  relationshipStatus,
  setRelationshipStatus,
  djScheduleEvents, 
  setShowEventModal, 
  setSelectedEvent, 
  handleFollow, 
  handleUnfollow, 
  handleFriendRequest, 
  renderReactionButtons 
}) => {
  if (!show) return null;
  
  return ReactDOM.createPortal(
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.9)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10002,
            padding: '1rem'
          }}
          onClick={() => {
            onClose();
            setRelationshipStatus(null);
          }}
        >
          <div
            style={{
              width: '90%',
              maxWidth: '900px',
              maxHeight: '90vh',
              background: 'rgba(26, 26, 46, 0.98)',
              borderRadius: '16px',
              overflow: 'hidden',
              border: '3px solid #ff00ff',
              display: 'flex',
              flexDirection: 'column'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* DJ Schedule Header */}
            <div style={{
              padding: '2rem',
              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
              flexShrink: 0
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <h2 style={{
                    fontSize: '2rem',
                    fontWeight: '700',
                    color: '#fff',
                    margin: '0 0 0.5rem 0'
                  }}>
                    🎧 {selectedDJ.user_name}
                  </h2>
                  <p style={{
                    fontSize: '1rem',
                    color: 'rgba(255, 255, 255, 0.7)',
                    margin: '0 0 1.5rem 0'
                  }}>
                    {selectedDJ.event_count} upcoming {selectedDJ.event_count === 1 ? 'event' : 'events'}
                  </p>
                  
                  {/* Follow and Friend Request Buttons */}
                  {relationshipStatus && !relationshipStatus.is_self && (
                    <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                      {!relationshipStatus.is_following ? (
                        <button
                          onClick={() => handleFollow(selectedDJ.user_id)}
                          style={{
                            padding: '0.4rem 0.75rem',
                            background: 'rgba(0, 255, 255, 0.2)',
                            border: '1px solid rgba(0, 255, 255, 0.4)',
                            borderRadius: '6px',
                            color: '#00ffff',
                            fontSize: '0.8rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.4rem',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(0, 255, 255, 0.3)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(0, 255, 255, 0.2)';
                          }}
                        >
                          <UserPlus size={14} /> Follow
                        </button>
                      ) : (
                        <button
                          onClick={() => handleUnfollow(selectedDJ.user_id)}
                          style={{
                            padding: '0.4rem 0.75rem',
                            background: 'rgba(0, 255, 255, 0.2)',
                            border: '1px solid rgba(0, 255, 255, 0.4)',
                            borderRadius: '6px',
                            color: '#00ffff',
                            fontSize: '0.8rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.4rem',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(0, 255, 255, 0.3)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(0, 255, 255, 0.2)';
                          }}
                        >
                          <UserCheck size={14} /> Following
                        </button>
                      )}
                      
                      {!relationshipStatus.is_friend && !relationshipStatus.friend_request_sent && !relationshipStatus.friend_request_pending && (
                        <button
                          onClick={() => handleFriendRequest(selectedDJ.user_id)}
                          style={{
                            padding: '0.4rem 0.75rem',
                            background: 'rgba(255, 0, 255, 0.2)',
                            border: '1px solid rgba(255, 0, 255, 0.4)',
                            borderRadius: '6px',
                            color: '#ff00ff',
                            fontSize: '0.8rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.4rem',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 0, 255, 0.3)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 0, 255, 0.2)';
                          }}
                        >
                          <UserPlus size={14} /> Add Friend
                        </button>
                      )}
                      
                      {relationshipStatus.friend_request_sent && (
                        <span style={{
                          padding: '0.4rem 0.75rem',
                          background: 'rgba(255, 165, 0, 0.2)',
                          border: '1px solid rgba(255, 165, 0, 0.4)',
                          borderRadius: '6px',
                          color: '#ffa500',
                          fontSize: '0.8rem',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.4rem'
                        }}>
                          Request Sent
                        </span>
                      )}
                      
                      {relationshipStatus.is_friend && (
                        <span style={{
                          padding: '0.4rem 0.75rem',
                          background: 'rgba(0, 255, 0, 0.2)',
                          border: '1px solid rgba(0, 255, 0, 0.4)',
                          borderRadius: '6px',
                          color: '#00ff00',
                          fontSize: '0.8rem',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.4rem'
                        }}>
                          <UserCheck size={14} /> Friends
                        </span>
                      )}
                    </div>
                  )}
                </div>

                <button
                  onClick={() => {
                    onClose();
                    setRelationshipStatus(null);
                  }}
                  style={{
                    background: 'rgba(255, 0, 128, 0.2)',
                    border: '1px solid rgba(255, 0, 128, 0.4)',
                    color: '#ff0080',
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.25rem',
                    cursor: 'pointer',
                    flexShrink: 0
                  }}
                >
                  <X size={18} />
                </button>
              </div>
            </div>

            {/* DJ Schedule Content */}
            <div
              className="dj-schedule-scrollable"
              style={{
                padding: '2rem',
                overflowY: 'auto',
                flex: 1,
                WebkitOverflowScrolling: 'touch'
              }}
            >
              <style>{`
                .dj-schedule-scrollable::-webkit-scrollbar {
                  width: 8px;
                }
                .dj-schedule-scrollable::-webkit-scrollbar-track {
                  background: rgba(0, 0, 0, 0.2);
                  border-radius: 4px;
                }
                .dj-schedule-scrollable::-webkit-scrollbar-thumb {
                  background: rgba(255, 0, 255, 0.3);
                  border-radius: 4px;
                }
                .dj-schedule-scrollable::-webkit-scrollbar-thumb:hover {
                  background: rgba(255, 0, 255, 0.5);
                }
              `}</style>

              {djScheduleEvents.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem', color: 'rgba(255, 255, 255, 0.6)' }}>
                  No upcoming events
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  {djScheduleEvents.map(event => {
                    const eventDate = new Date(event.event_date);
                    return (
                      <div
                        key={event.id}
                        onClick={() => {
                          setSelectedEvent(event);
                          setShowEventModal(true);
                        }}
                        style={{
                          background: 'rgba(255, 255, 255, 0.05)',
                          border: `2px solid ${getEventTypeColor(event.event_type)}`,
                          borderRadius: '12px',
                          padding: '1.5rem',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = `${getEventTypeColor(event.event_type)}20`;
                          e.currentTarget.style.transform = 'translateY(-4px)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                          e.currentTarget.style.transform = 'translateY(0)';
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                          <div>
                            <h3 style={{
                              fontSize: '1.25rem',
                              fontWeight: '700',
                              color: '#fff',
                              margin: '0 0 0.5rem 0',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.75rem',
                              flexWrap: 'wrap'
                            }}>
                              <span>{getEventTypeIcon(event.event_type)} {event.event_name}</span>
                              {event.is_live ? renderLiveIndicator(event, 'small') : event.is_over ? renderOverBadge(event, 'small') : null}
                            </h3>
                            <p style={{
                              fontSize: '1rem',
                              color: getEventTypeColor(event.event_type),
                              margin: 0
                            }}>
                              {event.venue_name}
                            </p>
                          </div>
                          <span style={{
                            padding: '0.5rem 1rem',
                            background: `${getEventTypeColor(event.event_type)}30`,
                            borderRadius: '8px',
                            fontSize: '0.85rem',
                            fontWeight: '600',
                            color: '#fff'
                          }}>
                            {event.event_type.replace('-', ' ').toUpperCase()}
                          </span>
                        </div>
                        
                        <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
                          <span style={{ color: 'rgba(255, 255, 255, 0.8)', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.9rem' }}>
                            <Calendar size={16} /> {eventDate.toLocaleDateString()}
                          </span>
                          <span style={{ color: 'rgba(255, 255, 255, 0.8)', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.9rem' }}>
                            <Clock size={16} /> {event.event_time}
                          </span>
                          <span style={{ color: 'rgba(255, 255, 255, 0.8)', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.9rem' }}>
                            <MapPin size={16} /> {event.location}
                          </span>
                          <span style={{ color: 'rgba(255, 255, 255, 0.8)', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.9rem' }}>
                            <Music2 size={16} /> {event.genre}
                          </span>
                        </div>
                        
                        {/* Reaction Buttons */}
                        {renderReactionButtons(event, 'small')}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>,
    document.body
  );
};

export default DJScheduleModal;
